export const PaymentSources = ['ach', 'check', 'wire'];
export const PaymentStates = ['complete', 'incomplete', 'returned'];
